<template>
	<div class="homePage_inlinet">
		<Panel hasShadow style="height: 488px" class="rank-pannel">
			<span class="font-h2-medium flex-row-align-center">
				样品转化
				<Explain :content="tipContent" class="ml-4" icon="icon-a-help-circlebangzhu-mian" size="20"></Explain>
			</span>
			<div class="main-content" v-loading="loading">
				<div class="pos-rela flex-row">
					<div class="left">
						<span class="Barlow-Bold fz-18 yx-color-text-primary white-bg pos-abso total-conversion-num">{{ totalRate | formatEmpty }}%</span>
					</div>
					<div class="content flex-row-align-center flex-1">
						<div class="flex-row flex-1">
							<div style="width: 160px">
								<div
									class="flex-row flex-align-start flex-just-end mt-32"
									:class="{ 'mt-4': !!index }"
									:style="'opacity: ' + setOpacity(index)"
									v-for="(item, index) in dataList"
									:key="item.key"
								>
									<div class="trapezoid primary-bg"></div>
									<div :style="'width: ' + (129 - index * 30) + 'px; height: 63px'" class="primary-bg"></div>
								</div>
							</div>
							<div class="flex-1">
								<div
									class="flex-row primary-bg flex-row-align-center flex-just-end pr-12 item mt-32"
									:class="[!!index ? ' mt-4' : '', `opacity-${1 + index}`]"
									style="height: 63px"
									v-for="(item, index) in dataList"
									:key="item.key"
								>
									<span class="Barlow-Bold yx-color-white">{{ item.value | formatEmpty | formatPrice2 }}</span>
									<span class="font-h6-regular yx-color-white ml-8">{{ item.label }}</span>
								</div>
							</div>
						</div>
						<div style="width: 130px">
							<div
								class="pl-4 flex-row-align-center mt-32"
								style="height: 63px"
								v-for="(item, index) in rateList"
								:key="item.key"
								:class="{ 'mt-12': !!index }"
							>
								<el-image :src="require('@/assets/public/home-back-icon-2.png')" class="mt-4" style="width: 16px" lazy></el-image>
								<div>
									<span class="yx-color-text-secondary font-h6-regular ml-4">{{ item.label }}</span>
									<span class="Barlow-Bold yx-color-text-primary ml-4">{{ item.value | formatEmpty }}%</span>
								</div>
							</div>
						</div>
						<div class="arrow"><i class="el-icon-caret-right"></i></div>
					</div>
				</div>
			</div>
		</Panel>
	</div>
</template>
<script>
import { getSampleConversion } from '@/api/home';
import Explain from '@/components/common/explain';
import { debounce } from 'lodash';
export default {
	props: {
		platformId: {
			type: [Number, String],
			default: null,
		},
		userIds: {
			type: Array,
			default: () => {
				return [];
			},
		},
		deptIds: {
			type: Array,
			default: () => {
				return [];
			},
		},
		params: {
			type: Object,
			default: () => {
				return {};
			},
		},
	},
	components: {
		Explain,
	},
	data() {
		return {
			dataList: [
				{ key: 'applyNum', label: '申样次数', value: '-' },
				{ key: 'sendNum', label: '寄样次数', value: '-' },
				{ key: 'deliveryNum', label: '交付次数', value: '-' },
				{ key: 'orderNum', label: '出单次数', value: '-' },
			],
			rateList: [
				{ key: 'sendRate', label: '寄样率', value: '-' },
				{ key: 'deliveryRate', label: '交付率', value: '-' },
				{ key: 'orderRate', label: '出单率', value: '-' },
			],
			totalRate: '-',
			loading: false,
		};
	},
	created() {
		this.tipContent =
			'申样次数：所选时间范围内创建的样品订单数\n寄样次数：所选时间范围内创建并发货的样品订单数\n交付数：所选时间范围内创建并交付的样品订单数\n出单数：所选时间范围内创建并有订单产生的样品订单数';
	},
	computed: {
		searchParameters() {
			return {
				platformId: this.platformId,
				deptIds: this.deptIds,
				userIds: this.userIds,
				startTime: this.params.from_time,
				endTime: this.params.to_time,
			};
		},
	},
	watch: {
		searchParameters: {
			handler() {
				this.getData();
			},
			deep: true,
		},
	},
	methods: {
		async getData() {
			this.loading = true;
			try {
				const { data } = await getSampleConversion({ ...this.searchParameters });
				this.dataList = this.dataList.map(item => ({ ...item, value: data[item.key] }));
				this.rateList = this.rateList.map(item => ({ ...item, value: data[item.key] }));
				this.totalRate = data?.applyOrderRate;
			} catch (error) {
				this.dataList = this.dataList.map(item => ({ ...item, value: undefined }));
				this.rateList = this.rateList.map(item => ({ ...item, value: undefined }));
				this.totalRate = undefined;
			} finally {
				this.loading = false;
			}
		},
		setOpacity(index) {
			return index === 0 ? 0.3 : Number(index) > 2 ? 0.8 : (0.3 * 100 + index * 0.16 * 100) / 100;
		},
	},
};
</script>
<style lang="less" scoped>
.rank-pannel {
	display: flex;
	/deep/ .panel-body {
		display: flex;
		width: 100%;
		box-sizing: border-box;
		flex-direction: column;
		.data-content {
			flex: 1;
			// display: flex
		}
	}
}
.main-content {
	flex: 1;
}
.pos-rela {
	padding-top: 20px;
	margin-top: -20px;
	position: relative;
	top: 50%;
	transform: translateY(-50%);
}
.left {
	position: absolute;
	top: -16px;
	left: 32px;
	width: 30px;
	height: 320px;
	border-top: 2px solid @color-gy4;
	border-left: 2px solid @color-gy4;
	border-bottom: 2px solid @color-gy4;
	border-radius: 20px 0 0 20px;
	.total-conversion-num {
		top: 148px;
		transform: translateX(-50%);
	}
}
.content {
	position: relative;
	margin-left: 84px;
	width: 100%;
	height: 218px;
	background-color: #fff;
	.arrow {
		position: absolute;
		width: 94px;
		height: 0;
		left: -22px;
		top: 286px;
		border-top: 1px solid @color-gy4;
		border-bottom: 1px solid @color-gy4;
		bottom: 8px;
		i {
			font-size: 24px;
			position: absolute;
			bottom: -12px;
			top: -12px;
			left: 84px;
			color: @color-gy4;
		}
	}
}
.primary-bg {
	background-color: @color-primary;
}
.trapezoid {
	margin-right: -18px;
	width: 50px;
	height: 63px;
	transform: skewX(30deg);
	border-radius: 4px 0 0 4px;
}
.opacity-4 {
	background-color: fadeout(@color-primary, 20);
}
.opacity-3 {
	background-color: fadeout(@color-primary, 38);
}
.opacity-2 {
	background-color: fadeout(@color-primary, 54);
}
.opacity-1 {
	background-color: fadeout(@color-primary, 70);
}
.item {
	border-radius: 0 4px 4px 0;
}
</style>
